import React from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";

export default function Loading({
  title,
  icon,
  description,
  btnText,
  onClose,
}) {
  const handleClose = () => onClose();

  return (
    <Modal.Body className="modal--lg">
      <Stack
        gap={4}
        className={`text-center img--round-before img--round-before-lg background-icon-lg background-icon-primary background-icon-${icon}`}
      >
        <h4 className="modal-body-heading-title mb-0">{title}</h4>
        {description && <p className="pt-0 mt-1">{description}</p>}
      </Stack>
      <Stack className="btn-group-flex">
        <Button size="lg" onClick={handleClose} disabled={true}>
          {btnText}
        </Button>
      </Stack>
    </Modal.Body>
  );
}
